import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace CWagsObedience {
  export const form: IEventRegisterRow[] = [
    // Level 1 with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_obedience_level_1,
          options: [
            { value: Constants.dog_class_element_level.cwags_obedience_level_1, id: Constants.dog_class_element_level.cwags_obedience_level_1 }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_obedience_a, id: Constants.dog_class_section.cwags_obedience_a },
            { value: Constants.dog_class_section.cwags_obedience_b, id: Constants.dog_class_section.cwags_obedience_b },
            { value: Constants.dog_class_section.cwags_obedience_to, id: Constants.dog_class_section.cwags_obedience_to },
            { value: Constants.dog_class_section.cwags_obedience_jr, id: Constants.dog_class_section.cwags_obedience_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    },
    // Level 2 with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_obedience_level_2,
          options: [
            { value: Constants.dog_class_element_level.cwags_obedience_level_2, id: Constants.dog_class_element_level.cwags_obedience_level_2 }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_obedience_a, id: Constants.dog_class_section.cwags_obedience_a },
            { value: Constants.dog_class_section.cwags_obedience_b, id: Constants.dog_class_section.cwags_obedience_b },
            { value: Constants.dog_class_section.cwags_obedience_to, id: Constants.dog_class_section.cwags_obedience_to },
            { value: Constants.dog_class_section.cwags_obedience_jr, id: Constants.dog_class_section.cwags_obedience_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    },
    // Level 3 with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_obedience_level_3,
          options: [
            { value: Constants.dog_class_element_level.cwags_obedience_level_3, id: Constants.dog_class_element_level.cwags_obedience_level_3 }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_obedience_a, id: Constants.dog_class_section.cwags_obedience_a },
            { value: Constants.dog_class_section.cwags_obedience_b, id: Constants.dog_class_section.cwags_obedience_b },
            { value: Constants.dog_class_section.cwags_obedience_to, id: Constants.dog_class_section.cwags_obedience_to },
            { value: Constants.dog_class_section.cwags_obedience_jr, id: Constants.dog_class_section.cwags_obedience_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    },
    // Level 4 with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_obedience_level_4,
          options: [
            { value: Constants.dog_class_element_level.cwags_obedience_level_4, id: Constants.dog_class_element_level.cwags_obedience_level_4 }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_obedience_a, id: Constants.dog_class_section.cwags_obedience_a },
            { value: Constants.dog_class_section.cwags_obedience_b, id: Constants.dog_class_section.cwags_obedience_b },
            { value: Constants.dog_class_section.cwags_obedience_to, id: Constants.dog_class_section.cwags_obedience_to },
            { value: Constants.dog_class_section.cwags_obedience_jr, id: Constants.dog_class_section.cwags_obedience_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    },
    // Level 5 with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_obedience_level_5,
          options: [
            { value: Constants.dog_class_element_level.cwags_obedience_level_5, id: Constants.dog_class_element_level.cwags_obedience_level_5 }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_obedience_a, id: Constants.dog_class_section.cwags_obedience_a },
            { value: Constants.dog_class_section.cwags_obedience_b, id: Constants.dog_class_section.cwags_obedience_b },
            { value: Constants.dog_class_section.cwags_obedience_to, id: Constants.dog_class_section.cwags_obedience_to },
            { value: Constants.dog_class_section.cwags_obedience_jr, id: Constants.dog_class_section.cwags_obedience_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    }
  ];
}

